import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingFlag: 0,
  data: [],
  masterData: {
    statusList: [],
  },
  error: false,
  errorMessage: null,
  candidateRating: 0,
  dropDownJobId: 0,
  EmployerValidationGetCertificationList: [],
  empUploadedList: [undefined],
  newCertificationsDuplicate: [],
  qaTabDuplicateDataV2: [],
  commentHistory:{
    emailHistory:[],
    textHistory:[],
    phoneHistory:[],
  },
  depsUnits:[]
};
export const candidateSearchViewSlice = createSlice({
  name: "candidateSearchViewInfo",
  initialState,
  reducers: {
    setCandidateSearchViewInfo: (state, action) => {
      state.data = action.payload;
    },
    setMasterData: (state, action) => {
      state.masterData.statusList = action.payload.status;
      state.masterData.locationList = action.payload.location;
    },
    setError: (state, action) => {
      state.error = true;
      state.errorMessage = action.payload;
    },
    resetError: (state) => {
      state.error = false;
      state.errorMessage = null;
    },
    setcandidateRating: (state, action) => {
      state.candidateRating = action.payload;
    },
    updatecandidateRating: (state, action) => {
      state.candidateRating = action.payload;
    },
    setCandidateLocationStatus: (state, action) => {
      state.candidateLocationStatus = action.payload;
    },
    setUpdateQA: (state, action) => {
      state.data = {
        ...state.data,
        qaTabDynamicDataV2: action.payload,
      };
    },
    setEmployerComments: (state, action) => {
      state.EmployerComments = action.payload;
    },
    setEmployerCommentsHistory: (state, action) => {
      state.EmployerCommentsHistory = action.payload;
    },
    setCertificationsEmployersCandidateValidation: (state, action) => {
      state.CertificationsEmployersCandidateValidation = action.payload;
    },
    setEmployerValidationGetCertificationList: (state, action) => {
      state.EmployerValidationGetCertificationList = action.payload;
    },
    setEmployersVerificationCommentsHistory: (state, action) => {
      state.EmployersVerificationCommentsHistory = action.payload;
    },
    setEmpUploadedList: (state, action) => {
      state.empUploadedList = action.payload;
    },
    setLoadingFlagIncrement: (state) => {
      state.loadingFlag = state.loadingFlag + 1;
    },
    setLoadingFlagDecrement: (state) => {
      if (state.loadingFlag !== 0) {
        state.loadingFlag = state.loadingFlag - 1;
      }
    },
    pageReset: () => initialState,
    setNewCertificationsDuplicateCopy: (state, action) => {
      state.newCertificationsDuplicate = action.payload
    },
    setQATabDuplicateDataV2: (state, action) => {
          state.qaTabDuplicateDataV2 = action.payload.qaTabDynamicDataV2
    },
    setCommentHistory:(state,action) => {
      state.commentHistory[action?.payload?.name] = action?.payload?.value
    },
    setValue:(state,{payload}) => {
      console.log({payload});
      state[payload?.name] = payload?.value
    }
  },
});

export const {
  setCandidateSearchViewInfo,
  setMasterData,
  setError,
  resetError,
  setcandidateRating,
  updatecandidateRating,
  setCandidateLocationStatus,
  setUpdateQA,
  setEmployerComments,
  setEmployerCommentsHistory,
  setCertificationsEmployersCandidateValidation,
  setEmployerValidationGetCertificationList,
  setUpdateCertificationsData,
  setEmployersVerificationCommentsHistory,
  setEmpUploadedList,
  setLoadingFlagIncrement,
  setLoadingFlagDecrement,
  pageReset,
  setNewCertificationsDuplicateCopy,
  setQATabDuplicateDataV2,
  setCommentHistory,
  setValue
} = candidateSearchViewSlice.actions;

export default candidateSearchViewSlice.reducer;
